import { render } from "./Blogs.vue?vue&type=template&id=24a2568a"
import script from "./Blogs.vue?vue&type=script&lang=js"
export * from "./Blogs.vue?vue&type=script&lang=js"

import "./Blogs.vue?vue&type=style&index=0&id=24a2568a&lang=css"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__